module.exports = __webpack_public_path__ + "assets/d2f61d535cd26d09ee47010f1885b21b-DSC_0802.jpg";